import React from 'react';
import LinkWithParams from 'components/LinkWithParams/LinkWithParams';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import { MD, XL, LG } from '@zendeskgarden/react-typography';
import {map} from 'lodash';
import { ItemCol, ItemRow } from './ServicesOffered.styles.js';
import { NavList, NavItem } from 'theme/Global.styles.js';

export const Image = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 0px;  
  background-color: rgb(255, 255, 255);
  height: 200px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
`


const ServicesOffered = (props) => {
  return (
      <ItemRow style={{marginTop: 0}}>
        <ItemCol size="12">
            {
              props.isFiltered ? null :
              <NavList style={{marginBottom: '40px'}}>
                {
                  map(props.services, (link, i) => {
                    // link = link.slug ? {title: link.title || link.name, link : `/c/equipment/${allServices[0].type}/${link.slug}`} : link
                    return (
                      <NavItem key={i}>
                        <NavLink exact activeClassName="active-content-link" to={`/services/${link.link}`}>
                          {link.tabTitle || link.title}
                        </NavLink>
                      </NavItem>
                    )
                  })
                }
              </NavList>
            }
          {
            map(props.activeService, (sc, i) => {
              return (
                <ItemRow key={i} style={{marginBottom: '60px'}}>

                  <ItemCol size="12">
                    {
                      props.isFiltered ? null :
                      <div>
                        <XL as="h2" bold paddingBottomSm>{sc.title}</XL>
                        <LG as="h3" style={{maxWidth: '1000px', marginBottom: '70px'}} slate>{sc.description}</LG>
                      </div>
                    }
                    <ItemRow key={i}>
                      {
                        map(sc.services, (s, n) => {
                          return (
                            <ItemCol key={`n-${n}`} size="12" md={4} extraPaddingRight>
                              <div>
                                <div>
                                  <Image alt={s.title} style={{backgroundImage: `url(${s.image || "https://www.mritechnologies.com/images/index-cover-rf.jpg"})`}}/>
                                </div>
                                {
                                  false ?
                                <LinkWithParams to="/services">
                                  <MD as="h2" uppercase paddingTopMd semibold blue tag="h3">{s.title}</MD>
                                </LinkWithParams> : 
                                <MD as="h2" uppercase paddingTopMd semibold blue tag="h3">{s.title}</MD>
                                }
                                <MD as="h3" paddingBottomMd paddingTopMd slate light tag="h3">
                                  {s.description}
                                </MD>
                                {/*<Link>See More</Link>*/}
                              </div>
                            </ItemCol>

                          )
                        })
                      }
                    </ItemRow>
                    
                  </ItemCol>
                </ItemRow>

              )
            })
          }
        </ItemCol>
        
      </ItemRow>
  )
}


export default ServicesOffered;
